var React = require('react');

function MoeInvoice (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M.818 0v74.705h63.088V17.427h-1.339L47.851 0H.818zm5 5H41.48v17.426h17.427v47.28H5.818V5zM46.48 6.123l9.544 11.303H46.48V6.124z","key":0}),React.createElement("path",{"d":"M15.34 36.949h34.044v-5H15.34zM15.34 48.802h34.044v-5H15.34zM15.34 60.655h34.044v-5H15.34z","key":1})]));
}

MoeInvoice.defaultProps = {"width":"64","height":"75"};

module.exports = MoeInvoice;

MoeInvoice.default = MoeInvoice;
